export const QUERY_GET_ALL: Array<{ key: string; value: string[] }> = [
  { key: 'GetAll', value: ['true'] }
];
